import springRadiance from "../img/buchete-de-primavara/1spring-radiance.webp";
import awakening from "../img/buchete-de-primavara/2awakening.webp";
import joyfulEssence from "../img/buchete-de-primavara/3joyful-essence.webp";
// import bloomBurst from "../img/buchete-de-primavara/4bloom-burst.webp";
import softlySpoken from "../img/buchete-de-primavara/5softly-spoken.webp";
import mistyBlossom from "../img/buchete-de-primavara/6misty-blossom.webp";
import blushRomance from "../img/buchete-de-primavara/7blush-romance.webp";
import tulipReverie from "../img/buchete-de-primavara/8tulip-reverie.webp";
import delicateSpring from "../img/buchete-de-primavara/9delicate-spring.webp";
// import cloudyDaydream from "../img/buchete-de-primavara/10cloudy-daydream.webp";
// import layersOfSun from "../img/buchete-de-primavara/11layers-of-sun.webp";
// import flameOfSpring from "../img/buchete-de-primavara/12flame-of-spring.webp";
// import springElegance from "../img/buchete-de-primavara/13spring-elegance.webp";
import springPoetry from "../img/buchete-de-primavara/14spring-poetry.webp";
import hush from "../img/buchete-de-primavara/15hush.webp";
import bloom from "../img/cele-mai-vindute/Bloom.webp";
import winterMorning from "../img/buchete-de-primavara/17winter-morning.webp";
import etherealBlush from "../img/buchete-de-primavara/18ethereal-blush.webp";
import colourfulGlow from "../img/buchete-de-primavara/19colourful-glow.webp";
// import sunshineBlooms from "../img/buchete-de-primavara/21sunshine-blooms.webp";
import paleSymphony from "../img/buchete/1pale-symphony.webp";
import petalAffair from "../img/buchete/3petal-affair.webp";
import prestigePetals from "../img/buchete/5prestige-petals.webp";
import petalEmbrace from "../img/buchete/6petal-embrace.webp";
import floralElegance from "../img/buchete/7floral-elegance.webp";
import grace from "../img/buchete/8grace.webp";
// import noble from "../img/buchete/9noble.webp";
import sereneBloom from "../img/buchete/10serene-bloom.webp";
import purity from "../img/buchete/11purity.webp";
import cheer from "../img/buchete/12cheer.webp";
import blushRose from "../img/buchete/13blush.webp";
// import illume from "../img/buchete/14illume.webp";
import featherlight from "../img/buchete/15featherlight.webp";
// import prestige from "../img/buchete/16prestige.webp";
import hydrangeaCascade from "../img/buchete/18cascade.webp";
import roselight from "../img/buchete/24roselight.webp";
// import finesse from "../img/buchete/25finesse.webp";
import snowdrop from "../img/buchete/26snowdrop.webp";
// import lunarBliss from "../img/buchete/28lunar-bliss.webp";
// import soothe from "../img/buchete/29soothe.webp";
import blueveil from "../img/buchete/30blueveil.webp";
import nobility from "../img/buchete/32nobility.webp";
import orchidMist from "../img/buchete/33orchid-mist.webp";
// import fuchsiaEmbrace from "../img/buchete/34fuchsia-embrace.webp";
// import bloomscape from "../img/buchete/35bloomscape.webp";
import marshmallowBloom from "../img/buchete/37marshmallow-bloom.webp";
import angelsTouch from "../img/buchete/38angels-touch.webp";
// import pinkMist from "../img/buchete/39pink-mist.webp";
// import delicacy from "../img/buchete/40delicacy.webp";
import rosewaterCharm from "../img/buchete/42rosewater-charm.webp";
// import moonlightPetals from "../img/buchete/44moonlight-petals.webp";
// import buttercream from "../img/buchete/46buttercream.webp";
import gemstone from "../img/buchete/47gemstone.webp";
// import roseDream from "../img/buchete/49rose-dream.webp";
import aura from "../img/buchete/50aura.webp";
import adore from "../img/buchete/54adore.webp";
// import eden from "../img/buchete/55eden.webp";
// import moonveil from "../img/buchete/56moonveil.webp";
import secretmix from "../img/new/024secretmix.webp";
import ethernaldream from "../img/new/021eternaldream.webp";
import springwaltz from "../img/new/014springwaltz.webp";
import royalgarden from "../img/new/017royalgarden.webp";
import pinkdelight from "../img/new/016pinkdelight.webp";
import silkspring from "../img/new/018silkspring.webp";
import marigold from "../img/new/001marigold.webp";
import hydrangeamelody from "../img/new/015hidrangeamelody.webp";
import primrose from "../img/new/002primrose.webp";
import dahlia from "../img/new/006dahlia.webp";
// import lovesgarden from "../img/new/008lovesgarden.webp";
// import zinnia from "../img/new/004zinnia.webp";
// import poppy from "../img/new/007poppy.webp";
import springsonet from "../img/new/012springsonet.webp";
import springtimeromance from "../img/new/010springtimeromance.webp";
import softrhapsody from "../img/new/011softrhapsody.webp";
import alpinePetals from "../img/feb2026/alpine_petals.webp";
import blushCascade from "../img/feb2026/blush_cascade.webp";
import blushTheory from "../img/feb2026/blush_theory.webp";
import lunaBloom from "../img/feb2026/luna_bloom.webp";
import merlot from "../img/feb2026/merlot.webp";
import moonlitRoses from "../img/feb2026/moonliit_roses.webp";
import petalMuse from "../img/feb2026/petal_muse.webp";
import pinkAura from "../img/feb2026/pink_aura.webp";
import pureWhite from "../img/feb2026/pure_white.webp";
import redMuse from "../img/feb2026/red_muse.webp";
import signaturePink from "../img/feb2026/signature_pink.webp";
import silkStem from "../img/feb2026/silk_stem.webp";
import velvetEarth from "../img/feb2026/velvet_earth.webp";
import wildHoney from "../img/feb2026/wild_honey.webp";
import royalMix from "../img/feb2026/01Royal_Mix.webp";
import blancAndRose from "../img/feb2026/02_Blanc_and_Rose.webp";
import gardeniaSignature from "../img/feb2026/03Gardenia_Signature.webp";
import gardenSmile from "../img/feb2026/04Garden_Smile.webp";
import jardinBlush from "../img/feb2026/05Jardin_blush.webp";
import tender from "../img/feb2026/06Tender.webp";
import signatureRoses from "../img/feb2026/07Signature_Roses.webp";
import FreshPink from "../img/feb2026/08Fresh_pink.webp";

//401-500
const paisprezeceFebruarie = [
  {
    id: 1515,
    name: "Royal Mix",
    price: "1000 lei",
    description: "Buchet format din trandafiri rosii, lalele si eucalipt. ",
    images: [royalMix],
  },

  {
    id: 1516,
    name: "Blanc and Rose",
    price: "1800 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri de tip Bujor, azotamus, oxypetalum si eucalipt. ",
    images: [blancAndRose],
  },
  {
    id: 1517,
    name: "Gardenia Signature",
    price: "1200 lei",
    description:
      "Buchet format din hortensie, trandafiri rosii, trandafiri de tip Bujor, oxypetalum si eucalipt. ",
    images: [gardeniaSignature],
  },
  {
    id: 1518,
    name: "Garden Smile",
    price: "850 lei",
    description:
      "Buchet format din 13 lalele olandeze de tip Bujor si matricaria. ",
    images: [gardenSmile],
  },
  {
    id: 1519,
    name: "Jardin Blush",
    price: "800 lei",
    description:
      "Buchet format din trandafiri de tip bujor, azotamus si eucalipt. ",
    images: [jardinBlush],
  },
  {
    id: 1520,
    name: "Tender",
    price: "1800 lei",
    description:
      "Buchet format din hortensie, trandafiri de tip Bujor, azotamus, gypsofila si eucalipt.",
    images: [tender],
  },
  {
    id: 1521,
    name: "Signature Roses",
    price: "2200 lei",
    description:
      "Buchet format din trandafiri de tip bujor, trandafiri crenguta si eucalipt. ",
    images: [signatureRoses],
  },
  {
    id: 1522,
    name: "Fresh Pink",
    price: "950 lei",
    description:
      "Buchet format din trandafiri de tip bujor si lalele olandeze de tip bujor si matricaria. ",
    images: [FreshPink],
  },
  {
    id: 1501,
    name: "Alpine Petals",
    price: "700 lei",
    description:
      "Buchet format din lalele, crizanteme, eustome, trandafir de tip bujor si eucalipt. ",
    images: [alpinePetals],
  },
  {
    id: 1502,
    name: "Blush Cascade",
    price: "2400 lei",
    description:
      "Buchet format din hortensie, trandafir de tip bujor si eustome. ",
    images: [blushCascade],
  },
  {
    id: 1503,
    name: "Blush Theory",
    price: "4900 lei",
    description:
      "Cos elegant format din trandafiri de tip bujor, lalele, frezie, ranuculus si eucalipt. ",
    images: [blushTheory],
  },
  {
    id: 1504,
    name: "Luna Bloom",
    price: "2300 lei",
    description:
      "Buchet format din trandafir de tip bujor, lalele si eucalipt. ",
    images: [lunaBloom],
  },
  {
    id: 1505,
    name: "Merlot",
    price: "1100 lei",
    description: "Buchet format din hortensie, trandafiri, ilex si eustome. ",
    images: [merlot],
  },
  {
    id: 1506,
    name: "Moonlit Roses",
    price: "950 lei",
    description:
      "Buchet format din trandafir de tip bujor, eustome si eucalipt. ",
    images: [moonlitRoses],
  },
  {
    id: 1507,
    name: "Petal Muse",
    price: "3200 lei",
    description:
      "Buchet format din hortensie, trandafir de tip bujor, crizanteme, ranuculus si frezie. ",
    images: [petalMuse],
  },
  {
    id: 1508,
    name: "Pink Aura",
    price: "1200 lei",
    description:
      "Buchet format din hortensie, trandafiri Sofia, crizanteme, eustome, trandafir de tip bujor si eucalipt. ",
    images: [pinkAura],
  },
  {
    id: 1509,
    name: "Pure White",
    price: "1000 lei",
    description:
      "Buchet format din hortensie, crizanteme, ranuculus, trandafir de tip bujor, gipsofila si eucalipt. ",
    images: [pureWhite],
  },
  {
    id: 1510,
    name: "Red Muse",
    price: "800 lei",
    description:
      "Buchet format din hortensie, crizanteme, trandafiri si eucalipt. ",
    images: [redMuse],
  },
  {
    id: 1511,
    name: "Signature Pink",
    price: "1100 lei",
    description:
      "Buchet format din hortensie, crizanteme, eustome, trandafir de tip bujor si eucalipt. ",
    images: [signaturePink],
  },
  {
    id: 1512,
    name: "Silk & Stem",
    price: "1400 lei",
    description:
      "Buchet format din trandafiri, ranuculus, eustome si eucalipt. ",
    images: [silkStem],
  },
  {
    id: 1513,
    name: "Velvet Earth",
    price: "1500 lei",
    description: "Buchet format din 15 trandafiri rosii si eucalipt. ",
    images: [velvetEarth],
  },
  {
    id: 1514,
    name: "Wild honey",
    price: "850 lei",
    description:
      "Buchet format din hortensie, trandafiri Sofia, dhiantus, trandafiri Lidia si eucalipt. ",
    images: [wildHoney],
  },

  // {
  //   id: 402,
  //   name: "Love's Garden",
  //   price: "900 lei",
  //   description: "Buchet format din trandafiri de tip crenguta si eucalipt.",
  //   images: [lovesgarden],
  // },
  {
    id: 403,
    name: "Ethernal Dream",
    price: "1300 lei",
    description:
      "Buchet format din hortensie, trandafiri de tip bujor, oxypetalum si eucalipt.",
    images: [ethernaldream],
  },
  {
    id: 432,
    name: "Bloom",
    price: "2100 lei",
    description:
      "Buchet superb format din trandafiri de tip Bujor, lalele și eucalipt.",
    images: [bloom],
  },
  {
    id: 413,
    name: "Hydrangea Melody",
    price: "3000 lei",
    description:
      "Buchet specgtaculos format din 7 hortensii si mix de trandafiri. ",
    images: [hydrangeamelody],
  },
  {
    id: 434,
    name: "Ethereal Blush",
    price: "1500 lei",
    description: "Buchet format dintr-un mix de lalele.",
    images: [etherealBlush],
  },
  // {
  //   id: 404,
  //   name: "Zinnia",
  //   price: "1300 lei",
  //   description: "Buchet format din trandafiri,eucalipt si asothamus.",
  //   images: [zinnia],
  // },
  {
    id: 405,
    name: "Spring Sonet",
    price: "650 lei",
    description:
      "Buchet format din trandafiri de tip crenguta, trandafiri de tip bujor, lalele si eucalipt.",
    images: [springsonet],
  },
  // {
  //   id: 406,
  //   name: "Poppy",
  //   price: "650 lei",
  //   description: "Buchet format din hortensie, trandafiri si eucalipt.",
  //   images: [poppy],
  // },

  {
    id: 408,
    name: "Springtime Romance",
    price: "1350 lei",
    description:
      "Buchet format din trandafiri de tip bujor, trandafiri Country si eucalipt.",
    images: [springtimeromance],
  },
  {
    id: 437,
    name: "Pale Symphony",
    price: "1400 lei",
    description:
      "Buchet elegant compus din hortensie, crizanteme, trandafiri de tip bujor, orhidei, gipsofila și eucalipt. ",
    images: [paleSymphony],
  },
  {
    id: 409,
    name: "Spring Waltz",
    price: "700 lei",
    description:
      "Buchet format din hortensie, gipsofila, trandafiri de tip bujor si eucalipt.",
    images: [springwaltz],
  },
  {
    id: 410,
    name: "Primrose",
    price: "1150 lei",
    description: "Buchet format din mix de lalele si gispofila alba. ",
    images: [primrose],
  },
  {
    id: 411,
    name: "Marigold",
    price: "2300 lei",
    description:
      "Buchet format din hortensii, trandafiri de tip bujor, trandafiri Avalanche, fresie si asothamus. ",
    images: [marigold],
  },
  {
    id: 412,
    name: "Dahlia",
    price: "1300 lei",
    description:
      "Buchet format din hortensie, trandafiri, lalele, asothamus si eucalipt. ",
    images: [dahlia],
  },

  {
    id: 414,
    name: "Pink Delight",
    price: "1300 lei",
    description:
      "Buchet format din trandafiri de tip bujor si verdeata decorativa.",
    images: [pinkdelight],
  },
  {
    id: 433,
    name: "Winter Morning",
    price: "1500 lei",
    description:
      "Buchet format din hortensie, fresie, trandafiri, lalele, gipsofila si eucalipt.",
    images: [winterMorning],
  },
  {
    id: 415,
    name: "Silk Spring",
    price: "500 lei",
    description:
      "Buchet format din trandafiri Sofia, dianthus, trandafiri crenguta si eucalipt.",
    images: [silkspring],
  },
  {
    id: 416,
    name: "Spring Radiance",
    price: "950 lei",
    description: "Buchet elegant compus din 21 de lalele. ",
    images: [springRadiance],
  },
  {
    id: 417,
    name: "Royal Garden",
    price: "1350 lei",
    description:
      "Buchet format din hortensie, trandafiri de tip crenguta, trandafiri rosii si eucalipt.",
    images: [royalgarden],
  },
  {
    id: 418,
    name: "Awakening",
    price: "450 lei",
    description:
      "Buchet format din lalele de tip bujor cu crengi decorative de primavara. ",
    images: [awakening],
  },
  {
    id: 419,
    name: "Joyful Essence",
    price: "900 lei",
    description: "Buchet format dintr-un mix de lalele, fresie si eucalipt.",
    images: [joyfulEssence],
  },
  // {
  //   id: 420,
  //   name: "Bloom Burst",
  //   price: "1000 lei",
  //   description:
  //     "Buchet superb din trandafiri, crizanteme, anturium, ilex si crengi decorative de brad.",
  //   images: [bloomBurst],
  // },
  {
    id: 421,
    name: "Softly Spoken",
    price: "950 lei",
    description: "Buchet elegant format din 21 de lalele.",
    images: [softlySpoken],
  },
  {
    id: 422,
    name: "Misty Blossom",
    price: "1050 lei",
    description:
      "Buchet elegant din trandafiri rosii, lalele de tip bujor si eucalipt.",
    images: [mistyBlossom],
  },
  {
    id: 423,
    name: "Blush Romance",
    price: "450 lei",
    description: "Buchet rafinat format din 9 lalele si verdeata decorativa.",
    images: [blushRomance],
  },
  {
    id: 424,
    name: "Tulip Reverie",
    price: "1800 lei",
    description: "Buchet elegant format din 45 de lalele rosii și eucalipt.",
    images: [tulipReverie],
  },
  {
    id: 425,
    name: "Delicate Spring",
    price: "1400 lei",
    description: "Buchet elegant format din 35 de lalele roz.",
    images: [delicateSpring],
  },
  // {
  //   id: 426,
  //   name: "Cloudy Daydream",
  //   price: "1300 lei",
  //   description:
  //     "Buchet format din hortensie, trandafiri, crizanteme, anturium si ilex.",
  //   images: [cloudyDaydream],
  // },
  // {
  //   id: 427,
  //   name: "Layers of Sun",
  //   price: "500 lei",
  //   description:
  //     "Buchet format din astromerie, trandafiri, lalele si verdeata decorativa.",
  //   images: [layersOfSun],
  // },
  // {
  //   id: 428,
  //   name: "Flame of Spring",
  //   price: "1300 lei",
  //   description:
  //     "Buchet format din lalele rosii, fresie si trandafiri de tip crenguta.",
  //   images: [flameOfSpring],
  // },
  // {
  //   id: 429,
  //   name: "Spring Elegance",
  //   price: "750 lei",
  //   description:
  //     "Buchet elegant din lalele de tip bujor, trandafiri si eucalipt.",
  //   images: [springElegance],
  // },
  {
    id: 430,
    name: "Spring Poetry",
    price: "2000 lei",
    description: "Buchet rafinat format din lalele de tip bujor.",
    images: [springPoetry],
  },
  {
    id: 431,
    name: "Hush",
    price: "1000 lei",
    description: "Buchet elegant format din lalele de tip bujor.",
    images: [hush],
  },

  // {
  //   id: 435,
  //   name: "Sunshine Blooms",
  //   price: "1300 lei",
  //   description: "Buchet format dintr-un mix de lalele si wax flower.",
  //   images: [sunshineBlooms],
  // },
  {
    id: 436,
    name: "Colourful Glow",
    price: "500 lei",
    description: "Buchet format din fresie, lalele si astromerie.",
    images: [colourfulGlow],
  },

  {
    id: 438,
    name: "Grace",
    price: "1400 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri de tip bujor si eucalipt.",
    images: [grace],
  },
  {
    id: 439,
    name: "Petal Affair",
    price: "1650 lei",
    description:
      "Buchet format din hortensie, bujori, trandafiri de tip bujori, crizanteme, eustome, matiole si gipsofila alba.",
    images: [petalAffair],
  },
  {
    id: 440,
    name: "Prestige Petals",
    price: "1300 lei",
    description:
      "Buchet format din hortensie, trandafiri de tip bujor și gipsofila.",
    images: [prestigePetals],
  },
  {
    id: 441,
    name: "Petal Embrace",
    price: "600 lei",
    description:
      "Buchet elegant format din trandafiri de tip bujor, crizanteme și gipsofila.",
    images: [petalEmbrace],
  },
  {
    id: 442,
    name: "Floral Elegance",
    price: "1000 lei",
    description:
      "Buchet elegant format din trandafiri de tip bujor si eustome.",
    images: [floralElegance],
  },
  // {
  //   id: 443,
  //   name: "Noble",
  //   price: "1700 lei",
  //   description:
  //     "Buchet elegant format din hortensie, crizanteme, trandafiri, eustome. anthurium si eucalipt.",
  //   images: [noble],
  // },
  {
    id: 444,
    name: "Serene Bloom",
    price: "800 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri. crizanteme, gipsofila si hypericum.",
    images: [sereneBloom],
  },
  {
    id: 407,
    name: "Soft Rhapsody",
    price: "550 lei",
    description: "Buchet format din hortensie si gipsofila alba.",
    images: [softrhapsody],
  },
  {
    id: 445,
    name: "Purity",
    price: "600 lei",
    description:
      "Buchet elegant format din trandafiri, crizanteme si gipsofila.",
    images: [purity],
  },
  // {
  //   id: 446,
  //   name: "Cheer",
  //   price: "900 lei",
  //   description:
  //     "Buchet elegant format din hortensie, trandafiri, crizanteme si verdeata decorativa.",
  //   images: [cheer],
  // },
  {
    id: 447,
    name: "Blush Rose",
    price: "950 lei",
    description:
      "Buchet elegant format din crizanteme, trandafiri de tip crenguta, eustome si eucalipt.",
    images: [blushRose],
  },
  // {
  //   id: 448,
  //   name: "Illume",
  //   price: "950 lei",
  //   description:
  //     "Buchet elegant format din hortensie, trandafiri,eustome si crizanteme.",
  //   images: [illume],
  // },
  {
    id: 449,
    name: "Featherlight",
    price: "700 lei",
    description:
      "Buchet elegant format din trandafiri de tip bujor, crizanteme si gipsofila.",
    images: [featherlight],
  },
  // {
  //   id: 450,
  //   name: "Prestige",
  //   price: "1800 lei",
  //   description:
  //     "Buchet elegant format din hortensie, trandafiri, gipsofila si eustome.",
  //   images: [prestige],
  // },
  {
    id: 451,
    name: "Hydrangea Cascade",
    price: "550 lei",
    description: "Buchet rafinat format din hortensie si gipsofila.",
    images: [hydrangeaCascade],
  },
  {
    id: 452,
    name: "Roselight",
    price: "800 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri de tip bujor, crizanteme si eustome.",
    images: [roselight],
  },
  // {
  //   id: 453,
  //   name: "Finesse",
  //   price: "500 lei",
  //   description: "Buchet elegant format din hortensie si gipsofila.",
  //   images: [finesse],
  // },
  {
    id: 454,
    name: "Snowdrop",
    price: "650 lei",
    description: "Buchet elegant format din crizanteme, trandafiri si eustome.",
    images: [snowdrop],
  },
  // {
  //   id: 455,
  //   name: "Lunar Bliss",
  //   price: "700 lei",
  //   description:
  //     "Buchet elegant format din trandafiri de tip bujor, crizanteme, eustome si eucalipt.",
  //   images: [lunarBliss],
  // },
  // {
  //   id: 456,
  //   name: "Soothe",
  //   price: "800 lei",
  //   description:
  //     "Buchet elegant format din trandafiri, crizanteme, gerbere si eustome.",
  //   images: [soothe],
  // },
  {
    id: 457,
    name: "Blueveil",
    price: "800 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri, crizanteme si eucalipt.",
    images: [blueveil],
  },
  {
    id: 458,
    name: "Nobility",
    price: "950 lei",
    description: "Buchet elegant format dintr-un mix de trandafiri si eustome.",
    images: [nobility],
  },
  {
    id: 459,
    name: "Orchid Mist",
    price: "800 lei",
    description: "Buchet elegant format din hortensie, crizanteme si orhidee.",
    images: [orchidMist],
  },
  {
    id: 401,
    name: "Secret Mix",
    price: "700 lei",
    description:
      "Buchet format din trandafiri de tip bujor, crizanteme, trandafiri Avalanche eucalipt și eustome.",
    images: [secretmix],
  },
  // {
  //   id: 460,
  //   name: "Fuchsia Embrace",
  //   price: "600 lei",
  //   description:
  //     "Buchet elegant format din crizanteme, trandafiri si eucalipt.",
  //   images: [fuchsiaEmbrace],
  // },
  // {
  //   id: 461,
  //   name: "Bloomscape",
  //   price: "950 lei",
  //   description:
  //     "Buchet elegant format din hortensie, crizanteme, trandafiri si eucalipt.",
  //   images: [bloomscape],
  // },
  {
    id: 462,
    name: "Marshmallow Bloom",
    price: "900 lei",
    description: "Buchet elegant format din hortensie, crizanteme si eustome.",
    images: [marshmallowBloom],
  },
  {
    id: 463,
    name: "Angel's Touch",
    price: "700 lei",
    description: "Buchet elegant format din hortensie si gipsofila colorata.",
    images: [angelsTouch],
  },
  // {
  //   id: 464,
  //   name: "Pink Mist",
  //   price: "950 lei",
  //   description:
  //     "Buchet elegant format din hortensie, trandafiri, crizanteme, eustome, anthurium si eucalipt.",
  //   images: [pinkMist],
  // },
  // {
  //   id: 465,
  //   name: "Delicacy",
  //   price: "750 lei",
  //   description:
  //     "Buchet elegant format din hortensie, crizanteme si gipsofila colorata.",
  //   images: [delicacy],
  // },
  {
    id: 466,
    name: "Rosewater Charm",
    price: "1000 lei",
    description:
      "Buchet elegant format din eustome, trandafiri de tip bujor, crizanteme si eucalipt.",
    images: [rosewaterCharm],
  },
  // {
  //   id: 467,
  //   name: "Moonlight Petals",
  //   price: "1000 lei",
  //   description:
  //     "Buchet elegant format din hortensie, crizanteme si trandafiri.",
  //   images: [moonlightPetals],
  // },
  // {
  //   id: 468,
  //   name: "Buttercream",
  //   price: "800 lei",
  //   description:
  //     "Buchet elegant format din trandafiri, gerbere, astromerie, crizanteme si eustome.",
  //   images: [buttercream],
  // },
  {
    id: 469,
    name: "Gemstone",
    price: "850 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri si gipsofila colorata.",
    images: [gemstone],
  },
  // {
  //   id: 470,
  //   name: "Rose Dream",
  //   price: "1700 lei",
  //   description:
  //     "Buchet elegant format din hortensie, trandafiri, wax flower si eucalipt.",
  //   images: [roseDream],
  // },
  {
    id: 471,
    name: "Aura",
    price: "1500 lei",
    description:
      "Buchet elegant format din hortensii, gipsofila colorata si eucalipt.",
    images: [aura],
  },
  {
    id: 472,
    name: "Adore",
    price: "1000 lei",
    description:
      "Buchet elegant format din hortensie, crizanteme, trandafiri si eustome.",
    images: [adore],
  },
  // {
  //   id: 473,
  //   name: "Eden",
  //   price: "1500 lei",
  //   description:
  //     "Buchet elegant format din hortensie, bujori, crizanteme, trandafiri, eustome si eucalipt.",
  //   images: [eden],
  // },
  // {
  //   id: 474,
  //   name: "Moonveil",
  //   price: "1100 lei",
  //   description:
  //     "Buchet elegant format din hortensie, trandafiri, crizanteme si eustome.",
  //   images: [moonveil],
  // },
];

export default paisprezeceFebruarie;
